import React from "react";
import "./styles.css";

const Navbar = ({
  countCartItems,
  cartItems,
  onAdd,
  onRemove,
  products,
  taxPrice,
  shippingPrice,
  totalPrice,
  itemsPrice,
}) => {
  const menu = document.querySelector(".nav__menu");
  const scrollToSection = (section_title) => {
    var ele = document.getElementById(section_title);
    window.scrollTo(ele.offsetLeft, ele.offsetTop);
  };
  const handleNavOpen = () => {
    const menu = document.querySelector(".nav__menu");

    const navLeft = menu.getBoundingClientRect().left;
    if (navLeft < 0) {
      menu.style.left = "0";
      document.body.classList.add("active");
    } else {
      menu.style.left = "-40rem";
      document.body.classList.remove("active");
    }
  };
  const handleNavClose = () => {
    const menu = document.querySelector(".nav__menu");

    const navLeft = menu.getBoundingClientRect().left;
    if (navLeft > 0) {
      menu.style.left = "0";
    } else {
      menu.style.left = "-40rem";
      document.body.classList.remove("active");
    }
  };

  // Smooth Scroll

  const navBar = document.querySelector(".navigation");
  const scrollLinks = document.querySelectorAll(".scroll-link");

  Array.from(scrollLinks).forEach((link) => {
    link.addEventListener("click", (e) => {
      // Prevent Default
      e.preventDefault();

      const id = e.currentTarget.getAttribute("href").slice(1);
      const element = document.getElementById(id);
      const navHeight = navBar.getBoundingClientRect().height;
      const fixNav = navBar.classList.contains("fix__nav");
      let position = element.offsetTop - navHeight;

      if (!fixNav) {
        position = position - navHeight;
      }

      window.scrollTo({
        left: "0",
        top: position,
      });

      menu.style.left = "-40rem";
      document.body.classList.remove("active");
    });
  });

  // FixNav

  window.addEventListener("scroll", () => {
    const navBar = document.querySelector(".navigation");

    const navHeight = navBar.getBoundingClientRect().height;
    const scrollHeight = window.pageYOffset;

    if (scrollHeight > navHeight) {
      navBar.classList.add("fix__nav");
    } else {
      navBar.classList.remove("fix__nav");
    }
  });
  return (
    <div className="navigation">
      <div className="container">
        <nav className="nav__center">
          <div className="nav__header">
            <div className="nav__logo">
              <h1>
                SHOPI<span>Q</span>
              </h1>
            </div>

            <div className="nav__hamburger" onClick={handleNavOpen}>
              <span>
                <svg>
                  <use xlinkHref="./images/sprite.svg#icon-menu"></use>
                </svg>
              </span>
            </div>
          </div>

          <div className="nav__menu">
            <div className="menu__top">
              <h1 className="nav__category">
                SHOPI<span>Q</span>
              </h1>
              <div className="close__toggle" onClick={handleNavClose}>
                <svg>
                  <use xlinkHref="./images/sprite.svg#icon-cross"></use>
                </svg>
              </div>
            </div>
            <ul className="nav__list">
              <li className="nav__item">
                <span
                  onClick={() => scrollToSection("header")}
                  className="nav__link scroll-link "
                >
                  Home
                </span>
              </li>

              <li className="nav__item">
                <span
                  onClick={() => scrollToSection("featured")}
                  className="nav__link scroll-link"
                >
                  Featured
                </span>
              </li>

              <li className="nav__item">
                <span
                  onClick={() => scrollToSection("blog")}
                  className="nav__link scroll-link"
                >
                  Blog
                </span>
              </li>

              <li className="nav__item">
                <span
                  onClick={() => scrollToSection("newsletter")}
                  className="nav__link scroll-link"
                >
                  Subscribe
                </span>
              </li>

              <li className="nav__item">
                <a href="/" className="nav__link">
                  Login
                </a>
              </li>

              <li className="nav__item">
                <a href="/" className="nav__link">
                  Register
                </a>
              </li>
            </ul>

            <ul className="nav__icons">
              <a href="/" className="icon__item">
                <svg>
                  <use xlinkHref="./images/sprite.svg#icon-search"></use>
                </svg>
              </a>

              <a href="/" className="icon__item">
                <svg>
                  <use xlinkHref="./images/sprite.svg#icon-user"></use>
                </svg>
              </a>

              <a href="/" className="icon__item">
                <svg>
                  <use xlinkHref="./images/sprite.svg#icon-shopping-basket"></use>
                </svg>
                <span>{countCartItems}</span>
              </a>
            </ul>

            {/* CART */}
            <aside className="block col-1 navbar-cart" style={{ padding: 20 }}>
              <h2>Cart Items</h2>
              <div>
                {cartItems.length === 0 && <div>Cart is empty</div>}
                {cartItems.map((item) => (
                  <div key={item.id} className="row">
                    <div className="col-2">{item.name}</div>
                    <div className="col-2">
                      <button onClick={() => onRemove(item)} className="remove">
                        -
                      </button>{" "}
                      <button onClick={() => onAdd(item)} className="add">
                        +
                      </button>
                    </div>

                    <div className="col-2 text-right">
                      {item.qty} x ${item.price.toFixed(2)}
                    </div>
                  </div>
                ))}

                {cartItems.length !== 0 && (
                  <>
                    <hr></hr>
                    <div className="row">
                      <div className="col-2">Items Price</div>
                      <div className="col-1 text-right">
                        ${itemsPrice.toFixed(2)}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-2">Tax Price</div>
                      <div className="col-1 text-right">
                        ${taxPrice.toFixed(2)}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-2">Shipping Price</div>
                      <div className="col-1 text-right">
                        ${shippingPrice.toFixed(2)}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-2">
                        <strong>Total Price</strong>
                      </div>
                      <div className="col-1 text-right">
                        <strong>${totalPrice.toFixed(2)}</strong>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <button
                        onClick={() => alert("Checkout to be implemented!")}
                      >
                        Checkout
                      </button>
                    </div>
                  </>
                )}
              </div>
            </aside>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
